@file:Suppress("ktlint:standard:no-wildcard-imports")

package xyz.malefic.multipage.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto
import xyz.malefic.multipage.i18n.t
import xyz.malefic.multipage.styles.Theme

@Composable
fun Footer() {
    Box(
        modifier =
            Modifier
                .fillMaxWidth()
                .backgroundColor(Theme.Primary)
                .color(Colors.White)
                .padding(top = 48.px, bottom = 72.px),
    ) {
        Column(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .maxWidth(1200.px)
                    .margin(leftRight = auto as CSSLengthOrPercentageNumericValue)
                    .padding(leftRight = 24.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Footer columns
            Row(
                modifier =
                    Modifier
                        .fillMaxWidth()
                        .gap(32.px)
                        .flexWrap(FlexWrap.Wrap)
                        .margin(bottom = 40.px),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                // Company column
                FooterColumn(
                    title = t("footer.company"),
                    items =
                        listOf(
                            t("footer.about") to "/about",
                            t("footer.story") to "/about",
                        ),
                )

                // Services column
                FooterColumn(
                    title = t("footer.services"),
                    items =
                        listOf(
                            t("services.ihinseiri.title") to "/services",
                            t("services.akiya.title") to "/services",
                            t("services.zaimu.title") to "/services",
                        ),
                )

                // Contact column
                FooterColumn(
                    title = t("footer.contact"),
                    items =
                        listOf(
                            t("footer.email") to "mailto:info@livstayjapan.co.jp",
                            t("footer.address") to "#",
                        ),
                )
            }

            // Email icon
            Row(
                modifier =
                    Modifier
                        .margin(bottom = 24.px)
                        .gap(16.px),
                horizontalArrangement = Arrangement.Center,
            ) {
                SocialIcon { FaEnvelope() }
            }

            // Copyright
            val currentYear = js("new Date().getFullYear()").toString()
            SpanText(
                text = "\u00A9 $currentYear ${t("footer.copyright")}",
                modifier =
                    Modifier
                        .fontSize(13.px)
                        .color(rgba(255, 255, 255, 0.6f)),
            )
        }
    }
}

@Composable
private fun FooterColumn(
    title: String,
    items: List<Pair<String, String>>,
) {
    Column(
        modifier =
            Modifier
                .classNames("ls-footer-col")
                .minWidth(180.px)
                .margin(bottom = 20.px)
                .gap(12.px),
    ) {
        SpanText(
            text = title,
            modifier =
                Modifier
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .margin(bottom = 12.px),
        )

        items.forEach { (text, link) ->
            val context = rememberPageContext()
            SpanText(
                text = text,
                modifier =
                    Modifier
                        .fontSize(14.px)
                        .color(rgba(255, 255, 255, 0.75f))
                        .cursor(Cursor.Pointer)
                        .textDecorationLine(TextDecorationLine.None)
                        .backgroundColor(Colors.Transparent)
                        .margin(0.px)
                        .onClick {
                            if (link.startsWith("mailto:")) {
                                js("window.location.href = 'mailto:info@livstayjapan.co.jp'")
                            } else if (link != "#") {
                                context.router.navigateTo(link)
                            }
                        },
            )
        }
    }
}

@Composable
private fun SocialIcon(icon: @Composable () -> Unit) {
    Box(
        modifier =
            Modifier
                .size(40.px)
                .backgroundColor(rgba(255, 255, 255, 0.1f))
                .borderRadius(50.percent)
                .cursor(Cursor.Pointer)
                .onClick {
                    js("window.location.href = 'mailto:info@livstayjapan.co.jp'")
                },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier =
                Modifier
                    .color(Colors.White)
                    .fontSize(18.px),
        ) {
            icon()
        }
    }
}
